import React, { useEffect, useState, useContext } from 'react';
import { Pie } from '@ant-design/plots';
import _ from 'lodash';
import {
    Col,
    Divider,
    Layout,
    Row,
    Spin,
    message,
    Collapse,
    Select,
} from 'antd';
import api from 'api';
import { get, post } from 'utils/fetch';
import { InvestmentItem, InvestmentRecord, NameItem } from 'types/investor';
import DollarCard, { DollarCardCurrency } from 'components/DollarCard';
import { AlignType } from 'rc-table/lib/interface';
import { USDollar } from 'utils/format';

import './Home.css';
import { AppHeader } from 'components/AppHeader';
import { isPhoneSize, truncateText } from 'utils/util';
import { AccountCreation } from 'pages/AccountCreation/AccountCreation';
import RequireAuth from 'components/Fief/RequireAuth';
import { GlobalContext } from 'GlobalContext';
import { formatCurrency } from 'utils/format';
import { USD_TO_CNY } from 'utils/format';
import { InvestmentTable } from './InvestmentTable';

type InvestmentPieDataType = {
    type?: string;
    value?: number;
    'Invested Amount'?: number;
    'Account balance'?: number;
    fund?: string;
    amount?: number;
    percentage?: string;
};

type InvestmentPieMouseEvent = {
    data: {
        data: InvestmentPieDataType;
    };
};

type InvestmentPieProps = {
    data: InvestmentPieDataType[];
};

type HomeInvestmentTableItem = {
    amount: number;
    entity_nameid: string;
    to_nameid: string;
    type: string;
    status: string;
    transaction_date?: string;
    contract_expiration_date?: string;
    dividend_interest_received?: number;
    principal_returned?: number;
    account_balance?: number;
    expected_return?: number;
    realized_return?: number;
    investment_id: number;
    accountId: number;
    account: string;
    currency: string;
};
// fund: key,
// amount: sumByFund[key].fundSum,
// percentage: sumByFund[key].percentage,
const InvestmentPie: React.FC<InvestmentPieProps> = ({
    data,
}: InvestmentPieProps) => {
    const config = {
        width: isPhoneSize() ? window.innerWidth - 20 : 750,
        height: isPhoneSize() ? 250 : 250,
        autoFit: true,
        data,
        interaction: {
            elementHighlight: true,
        },
        state: {
            inactive: { opacity: 0.5 },
        },
        tooltip: 'Percentage',
        angleField: 'value',
        colorField: 'fund',
        innerRadius: 0.6,
        label: {
            text: 'Percentage',
            style: {
                fontSize: 8,
                fill: '#000',
                fontWeight: 'bold',
                pointerEvents: 'none',
            },
        },
        legend: {
            color: {
                title: false,
                position: isPhoneSize() ? 'bottom' : 'right',
            },
            offsetY: 150,
        },
        annotations: [
            {
                type: 'text',
                style: {
                    text: 'Investment\nbreakdown',
                    x: '50%',
                    y: '50%',
                    textAlign: 'center',
                    // fontSize: 40,
                    fontStyle: 'bold',
                },
            },
        ],
    };
    return (
        <Pie
            {...config}
            // onReady={(plot) => {
            //     plot.chart.on(
            //         'interval:pointerover',
            //         (evt: InvestmentPieMouseEvent) => {
            //             plot.chart.emit('tooltip:show', {
            //                 data: { data: { type: evt.data.data.type } },
            //             });

            //             plot.chart.emit('element:highlight', {
            //                 data: { data: { type: evt.data.data.type } },
            //             });
            //         }
            //     );
            //     plot.chart.on(
            //         'interval:pointerout',
            //         (evt: InvestmentPieMouseEvent) => {
            //             plot.chart.emit('tooltip:hide', {
            //                 data: { data: { type: evt.data.data.type } },
            //             });
            //             plot.chart.emit('element:unhighlight', {
            //                 data: { data: { type: evt.data.data.type } },
            //             });
            //         }
            //     );
            // }}
        />
    );
};

type AreaItemType = {
    year: string;
    value: number;
};

interface HomeProps {
    setEmail: any;
    email: string | undefined;
    basicInfo: any;
    setBasicInfo: any;
    isOldUser: boolean;
}
const Home: React.FC<HomeProps> = ({
    email,
    setEmail,
    basicInfo,
    setBasicInfo,
    isOldUser,
}) => {
    const { accessToken, refreshSession, emailNoticeTransactionId } =
        useContext(GlobalContext);
    const [investmentsInfo, setInvestmentsInfo] = useState<Record<string, any>>(
        []
    );
    const [closedInvestmentsInfo, setClosedInvestmentsInfo] = useState<
        Record<string, any>
    >([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState<boolean>(true);
    const [displayInactiveFullTable, setDisplayInactiveFullTable] =
        useState<boolean>(false);
    const [activeInvestments, setActiveInvestments] = useState<
        InvestmentRecord[]
    >([]);
    const [transactions, setTransactions] = useState<any[]>([]);
    const [nameidMapping, setNameIDMapping] = useState<
        Record<string, NameItem>
    >({});
    const [fundTypeToView, setFundTypeToView] = useState<string>('Both');
    const displayErrorMessage = (message: string) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchTransactions(nameid: number) {
        await get(
            api.investor.getTransactions(nameid),
            setTransactions,
            (errors: any[]) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchInvestorInvestmentsTable(id: number) {
        await get(
            api.investor.getActiveInvestmentsTable(id),
            setInvestmentsInfo,
            (errors: any[]) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchInvestorClosedInvestmentsTable(id: number) {
        await get(
            api.investor.getClosedInvestmentsTable(id),
            setClosedInvestmentsInfo,
            (errors: any[]) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchCurrentUser() {
        return await 'e_00000021';
    }

    async function fetchData() {
        let nameid = await fetchCurrentUser();
        setLoading(false);
    }

    async function refreshPage() {
        async function callFetchData(basicInfo: Record<string, any>) {
            await fetchInvestorInvestmentsTable(basicInfo.id);
            await fetchInvestorClosedInvestmentsTable(basicInfo.id);

            await fetchTransactions(basicInfo.id);
            fetchData();
        }
        if (Object.keys(basicInfo).length === 0) return;
        callFetchData(basicInfo);
    }

    // 2
    useEffect(() => {
        if (accessToken === '') return;
        refreshPage();
    }, [basicInfo, accessToken]);

    useEffect(() => {
        setLoading(true);
    }, [basicInfo]);

    const HomeInvestmentTableItemColumns = [
        {
            title: 'Name',
            dataIndex: 'entity_nameid',
        },
        {
            title: 'Account',
            dataIndex: 'account',
        },
        {
            title: 'Fund',
            dataIndex: 'to_nameid',
        },
        {
            title: 'Funding Date',
            dataIndex: 'transaction_date',
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return (
                    new Date(a.transaction_date || '').valueOf() -
                    new Date(b.transaction_date || '').valueOf()
                );
            },
            render: (val: string) => val.slice(0, 10),
        },
        {
            title: 'Est. Maturity Date',
            dataIndex: 'actual_redemption_date',
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return (
                    new Date(a.transaction_date || '').valueOf() -
                    new Date(b.transaction_date || '').valueOf()
                );
            },
            render: (val: string) => val.slice(0, 10),
        },
        {
            title: 'Investment Category',
            dataIndex: 'type',
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return a.type.localeCompare(b.type);
            },
        },
        {
            title: 'Interest Rate (%)',
            dataIndex: 'interest',
            render: (val: string) => `${val}%`,
        },
        {
            title: 'Invested Amount',
            dataIndex: 'amount',
            align: 'right' as AlignType,
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return (a.amount || 0) - (b.amount || 0);
            },
            render: (_: number, record: HomeInvestmentTableItem) =>
                formatCurrency(record.amount, record.currency),
        },
        {
            title: 'Dividends/Interests Received',
            dataIndex: 'dividend_interest_received',
            align: 'right' as AlignType,
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return (a.amount || 0) - (b.amount || 0);
            },
            render: (_: number, record: HomeInvestmentTableItem) =>
                formatCurrency(
                    record.dividend_interest_received,
                    record.currency
                ),
        },
        {
            title: 'Principal Returned',
            dataIndex: 'principal_returned',
            align: 'right' as AlignType,
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return (a.amount || 0) - (b.amount || 0);
            },
            render: (_: number, record: HomeInvestmentTableItem) =>
                formatCurrency(record.principal_returned, record.currency),
        },
        {
            title: 'Account Balance',
            dataIndex: 'account_balance',
            align: 'right' as AlignType,
            sorter: (
                a: HomeInvestmentTableItem,
                b: HomeInvestmentTableItem
            ) => {
                return (a.amount || 0) - (b.amount || 0);
            },
            render: (_: number, record: HomeInvestmentTableItem) =>
                formatCurrency(record.account_balance, record.currency),
        },
        {
            title: 'Interest Strategy',
            dataIndex: 'method',
        },
    ];
    const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);

    const handleExpand = (expanded: boolean, record: any) => {
        if (expanded) {
            setExpandedRowKeys([String(record.investment_id)]);
        } else {
            setExpandedRowKeys([]);
        }
    };

    let content = null;
    if (loading) content = <Spin style={{ marginTop: '30px' }} />;
    else {
        const groupedData = _.groupBy(activeInvestments, (record) => {
            return [record.to_nameid, record.type];
        });
        let groupedDataWithSum: InvestmentItem[] = [];
        for (const key of Object.keys(groupedData)) {
            const [to_nameid, type] = key.split(',');
            let groupInvestmentAmount = 0;
            let legal_name = '';
            let investor_nameid = '';
            let address: string | undefined = '';
            for (const item of groupedData[key]) {
                legal_name = String(item.legal_name);
                investor_nameid = item.investor_nameid;
                groupInvestmentAmount += item.investment_amount;
                address = item.address;
            }
            groupedDataWithSum.push({
                investor_nameid,
                legal_name,
                to_nameid,
                type,
                address,
                amount: groupInvestmentAmount,
                investment_amount: groupInvestmentAmount,
            } as InvestmentItem);
        }
        let pieData = groupedDataWithSum.map(
            ({ to_nameid, type, investment_amount, address }) => {
                let name = nameidMapping[to_nameid]?.name || to_nameid;
                return {
                    // address,
                    type: `${address} (${USDollar.format(investment_amount)})`,
                    value: investment_amount,
                    'Invested Amount': investment_amount,
                };
            }
        );
        // Calculate total value
        const total = pieData.reduce((sum, item) => sum + item.value, 0);
        // total account balance
        const accountBalanceSum = _.sumBy(
            Object.values(investmentsInfo),
            (inv) =>
                inv.currency.toLowerCase() === 'cny'
                    ? inv.account_balance / 7.15
                    : inv.account_balance
        );
        // group info by fund
        const groupByFund = _.groupBy(investmentsInfo, ({ fund_name }) =>
            truncateText(fund_name, 25)
        );
        // {fund, {sum, percent}}
        const sumByFund = _.mapValues(groupByFund, (investments) => {
            const fundSum = _.sumBy(investments, (inv) =>
                inv.currency.toLowerCase() === 'cny'
                    ? inv.account_balance / 7.15
                    : inv.account_balance
            );
            const percentage = `${((fundSum / accountBalanceSum) * 100).toFixed(
                2
            )}%`;
            return {
                fundSum,
                percentage,
            };
        });
        const resultArray = Object.keys(sumByFund).map((key) => {
            return {
                fund: `${key} (${USDollar.format(sumByFund[key].fundSum)})`,
                'Account balance': sumByFund[key].fundSum,
                Percentage: sumByFund[key].percentage,
                value: sumByFund[key].fundSum,
            };
        });

        // Add percentage to each data item
        const dataWithPercentage = pieData.map((item) => ({
            ...item,
            percent: ((item.value / total) * 100).toFixed(2) + '%',
        }));
        let totalActiveInvestment = 0;
        let totalClosedInvestment = 0;
        let totalDividentReceived = 0;
        let totalUSDActiveContribution = 0;
        let totalCNYActiveContribution = 0;
        let totalUSDDividentReceived = 0;
        let totalCNYDividentReceived = 0;
        let hasUSDPosition = false;
        let hasCNYPosition = false;
        investmentsInfo.forEach((investment: any) => {
            totalActiveInvestment +=
                investment.currency.toLowerCase() === 'cny'
                    ? investment.account_balance / USD_TO_CNY
                    : investment.account_balance;
            totalDividentReceived +=
                investment.currency.toLowerCase() === 'cny'
                    ? investment.interest_received / USD_TO_CNY
                    : investment.interest_received;

            if (investment.currency.toLowerCase() === 'usd') {
                hasUSDPosition = true;
                totalUSDActiveContribution += investment.account_balance;
                totalUSDDividentReceived += investment.interest_received;
            }
            if (investment.currency.toLowerCase() === 'cny') {
                hasCNYPosition = true;
                totalCNYActiveContribution += investment.account_balance;
                totalCNYDividentReceived += investment.interest_received;
            }
        });
        closedInvestmentsInfo.forEach((investment: any) => {
            totalClosedInvestment +=
                investment.currency.toLowerCase() === 'cny'
                    ? investment.account_balance / USD_TO_CNY
                    : investment.account_balance;
            totalDividentReceived +=
                investment.currency.toLowerCase() === 'cny'
                    ? investment.interest_received / USD_TO_CNY
                    : investment.interest_received;

            if (investment.currency.toLowerCase() === 'usd') {
                hasUSDPosition = true;
                totalUSDDividentReceived += investment.interest_received;
            }
            if (investment.currency.toLowerCase() === 'cny') {
                hasCNYPosition = true;
                totalCNYDividentReceived += investment.interest_received;
            }
        });

        const renderStats = () => (
            <div className="stat">
                <Row
                    gutter={[16, 24]}
                    style={isPhoneSize() ? { justifyContent: 'center' } : {}}
                >
                    <Col>
                        <DollarCardCurrency
                            title="Active Contributions"
                            amountUSD={totalUSDActiveContribution}
                            amountCNY={totalCNYActiveContribution}
                            hasUSDPosition={hasUSDPosition}
                            hasCNYPosition={hasCNYPosition}
                        />
                    </Col>
                    <Col>
                        <DollarCardCurrency
                            title="Total Dividends/Interest Received"
                            amountUSD={totalUSDDividentReceived}
                            amountCNY={totalCNYDividentReceived}
                            hasUSDPosition={hasUSDPosition}
                            hasCNYPosition={hasCNYPosition}
                        />
                    </Col>
                    <Col>
                        <DollarCard
                            title="Active Projects Invested"
                            amount={
                                Array.from(
                                    new Set(
                                        investmentsInfo.map(
                                            (investment: any) => investment.name
                                        )
                                    )
                                ).length
                            }
                            isDollarFormat={false}
                        />
                    </Col>
                </Row>
            </div>
        );

        const onTableCollapse = (keys: string | string[]) => {
            setDisplayInactiveFullTable(keys.includes('inactive_investment'));
        };

        content = (
            <div
                style={
                    isPhoneSize()
                        ? {}
                        : {
                              overflowY: 'scroll',
                              overflowX: 'hidden',
                              scrollbarWidth: 'none',
                              height: 'calc(100vh - 50px)', //, background: "#F7F7F9", padding: "10px", borderRadius: "15px"
                          }
                }
            >
                <Layout style={{ width: '100%', background: 'transparent' }}>
                    <h3
                        style={{
                            padding: '0px',
                            color: '#121026',
                            margin: '0',
                            fontSize: '20px',
                            fontFamily: 'Arial',
                            fontWeight: 'bold',
                            lineHeight: '32px',
                            letterSpacing: '0em',
                        }}
                    >
                        Overview
                    </h3>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            overflowX: 'scroll',
                            scrollbarWidth: 'none',
                        }}
                    >
                        <InvestmentPie data={resultArray} />
                    </div>
                    <Divider style={{ margin: '0px', marginBottom: '20px' }} />
                    {renderStats()}
                    <Divider style={{ margin: '20px', marginBottom: '10px' }} />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                marginRight: '10px',
                                alignItems: 'center',
                            }}
                        >
                            Filter Fund type
                        </div>
                        <Select
                            onChange={(e) => setFundTypeToView(e)}
                            // placeholder="Filter Fund Type"
                            defaultValue={'Both'}
                            style={{
                                width: '200px',
                                background: 'transparent',
                            }}
                            optionFilterProp="children"
                            options={[
                                {
                                    value: 'Both',
                                    label: 'Both',
                                },
                                {
                                    value: 'Debt',
                                    label: 'Debt',
                                },
                                {
                                    value: 'Equity',
                                    label: 'Equity',
                                },
                            ]}
                        ></Select>
                    </div>
                    <Collapse
                        onChange={onTableCollapse}
                        style={{ width: '100%', zIndex: 0 }}
                        defaultActiveKey={['active_investment']}
                        ghost
                        items={[
                            {
                                key: 'active_investment',
                                label: 'Active Investment',
                                children: (
                                    <div>
                                        <InvestmentTable
                                            investmentsInfo={investmentsInfo}
                                            basicInfo={basicInfo}
                                            fundTypeToView={fundTypeToView}
                                            HomeInvestmentTableItemColumns={
                                                HomeInvestmentTableItemColumns
                                            }
                                            transactions={transactions}
                                            refreshPage={refreshPage}
                                            expandedRowKeys={expandedRowKeys}
                                            handleExpand={handleExpand}
                                        />
                                    </div>
                                ),
                            },
                            {
                                key: 'inactive_investment',
                                label: 'Closed Investment',
                                children: (
                                    <div>
                                        <InvestmentTable
                                            investmentsInfo={
                                                closedInvestmentsInfo
                                            }
                                            basicInfo={basicInfo}
                                            fundTypeToView={fundTypeToView}
                                            HomeInvestmentTableItemColumns={
                                                HomeInvestmentTableItemColumns
                                            }
                                            transactions={transactions}
                                            refreshPage={refreshPage}
                                            expandedRowKeys={expandedRowKeys}
                                            handleExpand={handleExpand}
                                        />
                                    </div>
                                ),
                            },
                        ]}
                    />
                </Layout>
            </div>
        );
    }
    return (
        <>
            {emailNoticeTransactionId !== -1 && (
                <div style={{ width: '100vw', height: '100vh' }}></div>
            )}
            {accessToken !== '' &&
                Object.keys(basicInfo).length !== 0 &&
                basicInfo.legal_name === 'Visitor' &&
                !isOldUser && (
                    <AccountCreation
                        basicInfo={basicInfo}
                        setBasicInfo={setBasicInfo}
                    />
                )}

            {accessToken !== '' && isOldUser && (
                <RequireAuth setEmail={setEmail} email={email}>
                    <div
                        style={
                            isPhoneSize()
                                ? {
                                      display: 'flex',
                                      flexDirection: 'column',
                                      width: '100%',
                                  }
                                : {
                                      display: 'flex',
                                      flexDirection: 'column',
                                      width: '100%',
                                  }
                        }
                    >
                        {!isPhoneSize() && (
                            <AppHeader
                                setBasicInfo={setBasicInfo}
                                basicInfo={basicInfo}
                                setEmail={setEmail}
                            />
                        )}
                        {contextHolder}
                        {content}
                    </div>
                </RequireAuth>
            )}
        </>
    );
};

export default Home;
